export const secciones = {
  '1': 'NPS',
  '2': '陈述',
  '3': '控制问题',
  '4': '客层',
  '5': '公开问题',
  '6': '4所有实践',
  '7': '其他问题',
  '8': 'NOM035声明',
}
export const preguntas = {
  // '1': '单选项问题',
  '1': '多项选择题（单选按钮）',
  '2': '公开问题',
  '3': '声明',
  '4': '多项选择题（单选按钮）',
  '5': '4全部练习',
  '6': '多项选择题（“检查”按钮）',
  '7': 'NOM035声明',
  '8': '音讯',
}
export const abiertas = {
  '1': '开启文字',
  '2': '数字文字',
}
export const preguntasEspeciales = {
  '1': '普通问题',
  '2': '特殊问题',
}
